var map = {
	"./de.js": [
		"BpkI",
		15
	],
	"./en.js": [
		"AkSj",
		16
	],
	"./es.js": [
		"iDUC",
		17
	],
	"./fr.js": [
		"UHev",
		18
	],
	"./it.js": [
		"PeP/",
		19
	],
	"./ja.js": [
		"LPye",
		20
	],
	"./ru.js": [
		"sR4o",
		21
	],
	"./tr.js": [
		"r799",
		22
	],
	"./zh.js": [
		"YJMR",
		23
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "PKrk";
module.exports = webpackAsyncContext;